export function formatDuration(duration_ms) {
    if (duration_ms) {
        return `(${(duration_ms / 1000).toFixed(4)} seconds)`
    }

    return '';
}